// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` a {
   color: #87BFBB;
   text-decoration: none;
   background-color: transparent;
   font-size: 20px;
 }

 .main-conatiner {
   /* background: rgba(135, 191, 187, 1); */
   height: 100vh;
 }

 .custom-tabs {
   margin: 0;
   padding: 0;
   display: flex;
   flex-wrap: nowrap;
   flex-direction: row;
   overflow-x: auto;
   /* white-space: nowrap; */
   -webkit-overflow-scrolling: touch;
   scroll-behavior: smooth;
   scrollbar-width: none;
 }


 .custom-tabs::-webkit-scrollbar {
   display: none;
 }



 .custom-tabs .nav-item {
   margin: 0 10px;
 }

 .custom-tabs .nav-link {
   font-family: 'Open Sans', sans-serif;
   border: none;
   border-bottom: 3px solid transparent;
   color: #262e3d;
   font-weight: 600;
   font-size: 1.1rem;
   padding: 12px 20px;
   transition: all 0.3s ease;
   background-color: transparent;
 }

 .custom-tabs .nav-link:hover {
   color: #565b60;
   border-color: #565b60;
 }

 .custom-tabs .nav-link.active {
   color: #565b60 !important;
   border-bottom: 3px solid #565b60;
   background-color: transparent;
 }


 /* .tab-content-box {
   padding: 20px;
   background-color: #f8f9fa;
   border-radius: 10px;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
   margin-top: 15px;
 } */

 @media (max-width: 768px) {
   .custom-tabs .nav-item {
     margin-bottom: 10px;
   }

   .custom-tabs .nav-link {
     display: block;
     width: 100%;
     text-align: center;
   }

   .custom-tabs a {
     font-size: 15px!important;
   }
 }`, "",{"version":3,"sources":["webpack://./src/Pages/Fundproject/fundproject.css"],"names":[],"mappings":"CAGC;GACE,cAAc;GACd,qBAAqB;GACrB,6BAA6B;GAC7B,eAAe;CACjB;;CAEA;GACE,wCAAwC;GACxC,aAAa;CACf;;CAEA;GACE,SAAS;GACT,UAAU;GACV,aAAa;GACb,iBAAiB;GACjB,mBAAmB;GACnB,gBAAgB;GAChB,yBAAyB;GACzB,iCAAiC;GACjC,uBAAuB;GACvB,qBAAqB;CACvB;;;CAGA;GACE,aAAa;CACf;;;;CAIA;GACE,cAAc;CAChB;;CAEA;GACE,oCAAoC;GACpC,YAAY;GACZ,oCAAoC;GACpC,cAAc;GACd,gBAAgB;GAChB,iBAAiB;GACjB,kBAAkB;GAClB,yBAAyB;GACzB,6BAA6B;CAC/B;;CAEA;GACE,cAAc;GACd,qBAAqB;CACvB;;CAEA;GACE,yBAAyB;GACzB,gCAAgC;GAChC,6BAA6B;CAC/B;;;CAGA;;;;;;IAMG;;CAEH;GACE;KACE,mBAAmB;GACrB;;GAEA;KACE,cAAc;KACd,WAAW;KACX,kBAAkB;GACpB;;GAEA;KACE,yBAAyB;GAC3B;CACF","sourcesContent":[" @import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');\r\n\r\n\r\n a {\r\n   color: #87BFBB;\r\n   text-decoration: none;\r\n   background-color: transparent;\r\n   font-size: 20px;\r\n }\r\n\r\n .main-conatiner {\r\n   /* background: rgba(135, 191, 187, 1); */\r\n   height: 100vh;\r\n }\r\n\r\n .custom-tabs {\r\n   margin: 0;\r\n   padding: 0;\r\n   display: flex;\r\n   flex-wrap: nowrap;\r\n   flex-direction: row;\r\n   overflow-x: auto;\r\n   /* white-space: nowrap; */\r\n   -webkit-overflow-scrolling: touch;\r\n   scroll-behavior: smooth;\r\n   scrollbar-width: none;\r\n }\r\n\r\n\r\n .custom-tabs::-webkit-scrollbar {\r\n   display: none;\r\n }\r\n\r\n\r\n\r\n .custom-tabs .nav-item {\r\n   margin: 0 10px;\r\n }\r\n\r\n .custom-tabs .nav-link {\r\n   font-family: 'Open Sans', sans-serif;\r\n   border: none;\r\n   border-bottom: 3px solid transparent;\r\n   color: #262e3d;\r\n   font-weight: 600;\r\n   font-size: 1.1rem;\r\n   padding: 12px 20px;\r\n   transition: all 0.3s ease;\r\n   background-color: transparent;\r\n }\r\n\r\n .custom-tabs .nav-link:hover {\r\n   color: #565b60;\r\n   border-color: #565b60;\r\n }\r\n\r\n .custom-tabs .nav-link.active {\r\n   color: #565b60 !important;\r\n   border-bottom: 3px solid #565b60;\r\n   background-color: transparent;\r\n }\r\n\r\n\r\n /* .tab-content-box {\r\n   padding: 20px;\r\n   background-color: #f8f9fa;\r\n   border-radius: 10px;\r\n   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\r\n   margin-top: 15px;\r\n } */\r\n\r\n @media (max-width: 768px) {\r\n   .custom-tabs .nav-item {\r\n     margin-bottom: 10px;\r\n   }\r\n\r\n   .custom-tabs .nav-link {\r\n     display: block;\r\n     width: 100%;\r\n     text-align: center;\r\n   }\r\n\r\n   .custom-tabs a {\r\n     font-size: 15px!important;\r\n   }\r\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
